import React from 'react';
import { connect } from 'react-redux';
import PromiseCreator from 'promise-creator';
import PropTypes from 'prop-types';
import { changeUserInfoAction } from '../../redux/me';
import LakeCountyExtraInformation from './LakeCountyExtraInformation';
import NorthEastExtraInformation from '../ExtraUserInformation/NorthEastExtraInformation';
import SITE_MODES from '../../../constants/site-modes';

const ExtraUserInformation = ({
    changeUserInfo,
    companyDomain,
    siteMode,
}) => {
    if (siteMode !== SITE_MODES.EDUCATION) {
        return null;
    }
    let Form = null;
    if (companyDomain === 'clcillinois') {
        Form = LakeCountyExtraInformation;
    } else if (companyDomain === 'nwtc') {
        Form = NorthEastExtraInformation;
    } else {
        return null;
    }

    return (
        <Form
            onSubmit={(form) => {
                console.log('wiii')
                const { resolve, reject, promise } = PromiseCreator();
                changeUserInfo({
                    resolve,
                    reject,
                    ...form,
                });
                return promise;
            }}
        />
    );
};

ExtraUserInformation.propTypes = {
    changeUserInfo: PropTypes.func,
    siteMode: PropTypes.number,
    companyDomain: PropTypes.string,
};

export default connect(
    ({ theme }) => ({
        companyDomain: theme.companyDomain,
        siteMode: theme.siteMode,
        requestSecondaryEmail: theme.requestSecondaryEmail,
    }),
    {
        changeUserInfo: changeUserInfoAction,
    },
)(ExtraUserInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformationLakeCounty/ExtraUserInformation.js